import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Entity } from 'app/pages/product/product.model';
import { SystemService } from 'app/services/system.service';
import { AngularDualListBoxModule } from '../dual-list/angular-dual-listbox.module';
import { Permission, Role } from './role.model';
import { RoleService } from './role.service';

@Component({
  selector: 'role-form',
  templateUrl: './role-form.component.html',
  styleUrls: ['./role-form.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class RoleFormComponent implements OnInit {

    public contactForm: FormGroup;
    public action: string;
    public role: Role;
    allPermissions: Permission[];
    users: Entity[];
    format: any = { add: 'Agregar', remove: 'Quitar', all: 'Todos',
             none: 'Niguno', direction: 'left-to-right', draggable: false, locale: undefined };
    
    @Output()
    entityChanged: EventEmitter<any> = new EventEmitter();

    @Input()
    public title: string;

    constructor(private _formBuilder: FormBuilder,
                private roleService: RoleService,
                private _matSnackBar: MatSnackBar,
                public _systemService: SystemService) {
        // this.role = new Role();
     }

    ngOnInit(): void {
        // this.contactForm = this.createRoleForm();
        this.users = this._systemService.allUsers;
        this.allPermissions = this._systemService.allPermissions;
    }

    guardarRole(): void{
        const theRole: Role = new Role(this.contactForm.getRawValue());
        theRole.users = this.role.users;
        theRole.permissions = this.role.permissions;
        this.roleService.guardarRole(theRole).subscribe(
            resp => {
                 // Show the success message
                 this._matSnackBar.open('Rol guardado', 'OK', {
                    verticalPosition: 'top',
                    duration        : 4000
                });
                 this.entityChanged.emit(resp);
            }
        );
    }

    deleteRole(): void{

    }

    selected(entity: Entity): void{
        if (entity.id > 0) {
            this.roleService.getRole(entity.id)
                .subscribe(
                    resp => {
                        this.role = new Role(resp);
                        this.contactForm = this.createRoleForm();
                        this.ngOnInit();
                    }
                );
        }else{
            this.role = new Role(entity);
            this.contactForm = this.createRoleForm();
            this.ngOnInit();
        }
    }

    createRoleForm(): FormGroup
    {
        return this._formBuilder.group({
            id                  : [this.role.id],
            name                : [this.role.name],
            hourIncome          : [this.role.hourIncome],
            description         : [this.role.description],
        });
    }

}
